import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './Login';
import ForgotPassword from './ForgotPassword';
import Signup from './Signup';
import Layout from './Layout';
import VerifyOtp from './VerifyOtp';
import Details from './Details';
import ProfileImageUpload from './ProfileImageUpload';
import ChangePassword from './ChangePassword';
import Search from './Search';
import { AuthProvider } from "./AuthContext";
import PrivateRoute from "./PrivateRoute";
import ChatScreen from "./ChatScreen";
import UpdateDetailsForm from "./UpdateDetailsForm";
import DisplayProfileImages from "./DisplayProfileImages";
import InActiveAccount from "./InActiveAccount";
import AboutUs from "./AboutUs";
import PrivacyPolicy from "./PrivacyPolicy";
import ContactsUs from "./ContactsUs";
import { HelmetProvider } from "react-helmet-async"; // ✅ Add this



function App() {
  const tokenRef = useRef(null);

  return (
        <HelmetProvider>
    <AuthProvider>
    <Router>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<LoginPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="ForgotPassword" element={<ForgotPassword />} />
        <Route path="ChangePassword" element={<ChangePassword />} />
        <Route path="Signup" element={<Signup />} />
        <Route path="VerifyOtp" element={<VerifyOtp tokenRef={tokenRef} />} />
        <Route path="Details" element={<Details tokenRef={tokenRef} />} />
        <Route path="ProfileImageUpload" element={<ProfileImageUpload tokenRef={tokenRef} />} />
        <Route path="ChangePassword" element={<ChangePassword tokenRef={tokenRef} />} />
        <Route path="Search" element={<PrivateRoute><Search /></PrivateRoute>} />
        <Route path="ChatScreen" element={<PrivateRoute><ChatScreen /></PrivateRoute>} />
         <Route path="UpdateDetailsForm" element={<PrivateRoute><UpdateDetailsForm /></PrivateRoute>} />
         <Route path="DisplayProfileImages" element={<PrivateRoute><DisplayProfileImages /></PrivateRoute>} />
         <Route path="InActiveAccount" element={<PrivateRoute><InActiveAccount /></PrivateRoute>} />

          <Route path="ContactsUs" element={<ContactsUs />} />
          <Route path="AboutUs" element={<AboutUs />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
      </Route>
    </Routes>
    </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}


export default App;
